'use strict';
const schema_1 = require("../schema");
module.exports = new schema_1.Schema({
    include: [
        require('./json')
    ]
});
//# sourceMappingURL=core.js.map